// Determines if the provided date is a valid Date object.
// https://stackoverflow.com/a/44198641
export function isValidDate(date) {
    return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
}

// Takes a date object and returns a DB date string eg '2018-09-28'
export function dateFormatForDB(d) {
    if ( !isValidDate(d) ) { return '' };
    const day = ("0" + d.getDate()).slice(-2);
    const month = ("0"+(d.getMonth()+1)).slice(-2);
    const year = d.getFullYear();
    return year + '-' + month + '-' + day;
}

// http://stackoverflow.com/questions/10193294/how-can-i-tell-if-a-browser-supports-input-type-date
export function checkDateInput() {
    const input = document.createElement('input');
    input.setAttribute('type','date');

    const notADateValue = 'not-a-date';
    input.setAttribute('value', notADateValue);

    return !(input.value === notADateValue);
}

export function datePlusDays(date, days=1) {
    date = new Date(date); // Duplicate the passed in date!
    return( new Date(
        date.setDate(date.getDate() + days)
    ) );
}

// Return a new date object with the number of days from today added.
export function dateFromToday(days=1) {
    let today = new Date();
    today.setHours(0,0,0,0);
    return datePlusDays(today, days);
}

export function todayStart() {
    let date = new Date();
    date.setHours(0,0,0,0);
    return date;
}

export function todayEnd() {
    let date = new Date();
    date.setHours(23,59,59,999)
    return date;
}

export function isToday(date) {
    if (!date) { return false };
    date = new Date(date); // Duplicate the passed in date!
    let todayStart = todayStart();
    let todayEnd = todayEnd();
    if ( date.getTime() < todayEnd.getTime() && date.getTime() > todayStart.getTime() ) { return true };
    return false;
}

export function isTodayOrEarlier(date) {
    if (!date) { return false };
    date = new Date(date); // Duplicate the passed in date!
    if (date.getTime() < todayEnd()) { return true };
    return false;
}